import { ref } from "vue";

export const forceSelectOptionHappy = ref(false)